import { render, staticRenderFns } from "./Actualizacion.vue?vue&type=template&id=056172fd&"
import script from "./Actualizacion.vue?vue&type=script&lang=js&"
export * from "./Actualizacion.vue?vue&type=script&lang=js&"
import style0 from "./Actualizacion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports